import client from '../client';
import endpoints from '../endpoints';

/**
 * 차량 관리 — 관리자 API
 * API_DOCS: 22. 관리자 - 차량
 *
 * GET    /api/admin/vehicles
 * POST   /api/admin/vehicles
 * PUT    /api/admin/vehicles/{vehicle_id}
 * DELETE /api/admin/vehicles/{vehicle_id}
 */

export const getVehicles = async (params = {}) => {
  const res = await client.get(endpoints.admin.vehicles.list, { params });
  return res.data;
};

export const getVehicleById = async (id) => {
  const res = await client.get(endpoints.admin.vehicles.detail(id));
  return res.data;
};

export const createVehicle = async (data) => {
  const res = await client.post(endpoints.admin.vehicles.list, data);
  return res.data;
};

export const updateVehicle = async (id, data) => {
  const res = await client.put(endpoints.admin.vehicles.detail(id), data);
  return res.data;
};

export const deleteVehicle = async (id) => {
  const res = await client.delete(endpoints.admin.vehicles.detail(id));
  return res.data;
};
